import React, { useState,  useEffect } from 'react';
import { Routes, Route, Router, useNavigate, BrowserRouter } from 'react-router-dom';
import ApplicationContextProvider, { useAppCtx } from './app-ctx';
import Index from './index';

const IndexRouter = () => {
    const context = useAppCtx(); // Ensure context is used inside

    return (
        <BrowserRouter>
            <Index />
        </BrowserRouter>
    );
}

export default IndexRouter
